export default "__VITE_ASSET__DQUoSlyj__"